import type React from 'react';

const mergeRefs =
    <T>(...refs: (React.Ref<T> | undefined)[]) =>
    (node: T) => {
        for (const ref of refs) {
            if (typeof ref === 'function') ref(node);
            else if (ref) ref.current = node;
        }
    };

export default mergeRefs;
